import  { useEffect, useState, useMemo } from "react";
import axios from "../../utils/axiosInstance";
import ButtonSimp from "../../components/button";
import { FaEdit, FaTimes } from "react-icons/fa";
import Modal from "../../components/modal/Modal";
import SelectBox from "../../components/edittext/selectbox/SelectBox";

import BasicInput from "../../components/edittext/basicInput/basicInput";
import { ChevronDown, ChevronUp } from "lucide-react";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const itemsPerPage = 5;
  const handleEditOrder = (order) => {
    setSelectedOrder(order);
    setModalOpen(true);
  };
  const fetchOrders = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/orders/getorders", {
        withCredentials: true,
      });
      setOrders(res.data.data || []);
    } catch (err) {
      console.error("خطا در گرفتن سفارشات:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const SearchOrders = useMemo(() => {
    let result = [...orders];

    // فیلتر بر اساس سرچ
    if (search) {
      result = result.filter((c) =>
        c._id.slice(-6).toLowerCase().includes(search.toLowerCase())
      );
    }

    // فیلتر بر اساس بازه زمانی
    if (startDate) {
      result = result.filter(
        (c) => new Date(c.createdAt) >= new Date(startDate)
      );
    }
    if (endDate) {
      result = result.filter((c) => new Date(c.createdAt) <= new Date(endDate));
    }

    return result;
  }, [orders, search, startDate, endDate]);

  // محاسبه صفحه‌بندی
  const totalPages = Math.ceil(SearchOrders.length / itemsPerPage);
  const paginatedOrders = SearchOrders.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const updateOrderStatus = async (orderId, status) => {
    try {
      await axios.put(
        `/orders/${orderId}/status`,
        { status },
        { withCredentials: true }
      );
      fetchOrders();
      setSelectedOrder(null);
    } catch (err) {
      console.error("خطا در تغییر وضعیت سفارش:", err);
    }
  };

  const toggleExpand = (id) => {
    setExpanded(expanded === id ? null : id);
  };

  return (
    <div className="p-4">
      <h2>Manage Orders</h2>
      <div className="row">
        <div className="p-0 col-12 col-lg-4">
          <BasicInput
            className="me-lg-1"
            bsize="1"
            bcolor="primary"
            margin="2"
            bgcolor="white"
            textcolor="black"
            scolor="primary"
            text="Order Number..."
            value={search}
            onChange={(value) => setSearch(value)}
          />
        </div>
        <div className="p-1 mt-1 col-6 col-lg-4">
          <BasicInput
            className="me-lg-1"
            type="date"
            bsize="1"
            bcolor="primary"
            margin="0"
            bgcolor="white"
            textcolor="black"
            scolor="primary"
            text="StartDate"
            value={startDate}
            onChange={(value) => {
              setStartDate(value);
              setCurrentPage(1);
            }}
          />
        </div>
        <div className="p-1 mt-1 col-6 col-lg-4">
          <BasicInput
            className=" me-lg-1"
            type="date"
            bsize="1"
            bcolor="primary"
            margin="0"
            bgcolor="white"
            textcolor="black"
            scolor="primary"
            text="EndDate"
            value={endDate}
            onChange={(value) => {
              setEndDate(value);
              setCurrentPage(1);
            }}
          />
        </div>

        {/* انتخاب بازه زمانی */}
        {/* <input
          type="date"
          className=" me-2"
          value={startDate}
          onChange={(e) => {
            setStartDate(e.target.value);
            setCurrentPage(1);
          }}
        />
        <input
          type="date"
          className="form-control"
          value={endDate}
          onChange={(e) => {
            setEndDate(e.target.value);
            setCurrentPage(1);
          }}
        /> */}
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div>
          {/* Desktop Table */}
          <div className="d-none d-lg-block mt-3">
            <table className="table table-striped w-100 table-hover">
              <thead>
                <tr>
                  <th>Order Number</th>
                  <th>Customer</th>
                  <th>Total Amount</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {SearchOrders.map((order) => (
                  <tr key={order._id}>
                    <td>{order._id.slice(-6)}</td>
                    <td>{order.userId?.name || "Unknown"}</td>
                    <td>{order.totalAmount}$</td>
                    <td>
                      <span
                        className={`badge ${
                          order.status === "Paid"
                            ? "bg-success"
                            : order.status === "Awaiting Payment"
                            ? "bg-warning"
                            : "bg-info"
                        }`}
                      >
                        {order.status}
                      </span>
                    </td>
                    <td>
                      {new Date(order.createdAt).toLocaleDateString("en-US")}
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-warning me-1"
                        onClick={() => handleEditOrder(order)}
                      >
                        <FaEdit />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Accordion */}
          <div className="d-lg-none mt-3">
            {paginatedOrders.map((order) => (
              <div
                key={order._id}
                className="border rounded mb-3 shadow-sm overflow-hidden"
              >
                <div
                  className="d-flex justify-content-between align-items-center p-2 bg-light"
                  onClick={() => toggleExpand(order._id)}
                  role="button"
                >
                  <div>
                    <strong>Order #{order._id.slice(-6)}</strong>
                    <div className="small text-muted">
                      {order.userId?.name || "Unknown"}
                    </div>
                  </div>
                  {expanded === order._id ? <ChevronUp /> : <ChevronDown />}
                </div>

                {expanded === order._id && (
                  <div className="p-2 small bg-white">
                    <div>
                      <strong>Total:</strong> {order.totalAmount}$
                    </div>
                    <div>
                      <strong>Status:</strong>{" "}
                      <span
                        className={`badge ${
                          order.status === "Paid"
                            ? "bg-success"
                            : order.status === "Awaiting Payment"
                            ? "bg-warning"
                            : "bg-info"
                        }`}
                      >
                        {order.status}
                      </span>
                    </div>
                    <div>
                      <strong>Date:</strong>{" "}
                      {new Date(order.createdAt).toLocaleDateString("en-US")}
                    </div>
                    <div className="mt-2">
                      <button
                        className="btn btn-sm btn-outline-warning"
                        onClick={() => handleEditOrder(order)}
                      >
                        Details
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
          {/* Pagination Controls */}
          <div className="d-flex justify-content-center mt-3">
            <nav>
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                  >
                    Previous
                  </button>
                </li>
                {Array.from({ length: totalPages }, (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() =>
                      setCurrentPage((p) => Math.min(p + 1, totalPages))
                    }
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      )}

      {/* Modal Order Details */}
      {selectedOrder && (
        <Modal show={modalOpen} modalClosed={() => setModalOpen(false)}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <ButtonSimp
                  margin="2"
                  size="sm"
                  color="danger"
                  text=""
                  clicked={() => setModalOpen(false)}
                >
                  <FaTimes />
                </ButtonSimp>
                <h5 className="modal-title">Order Details</h5>
              </div>
              <div className="modal-body">
                <div className="card">
                  <div className="card-body">
                    <p>
                      <strong>Customer:</strong> {selectedOrder.userId?.name}
                    </p>
                    <p>
                      <strong>Email:</strong> {selectedOrder.userId?.email}
                    </p>
                    <p>
                      <strong>Phone:</strong> {selectedOrder.userId?.phone}
                    </p>
                    <p>
                      <strong>Address:</strong> {selectedOrder.userId?.address}
                    </p>

                    <h6 className="mt-3 fw-bold">Items:</h6>
                    <ul className="list-group mb-3">
                      {selectedOrder.items.map((item, i) => (
                        <li
                          key={i}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <img
                            className="img-thumbnail"
                            style={{ width: "90px", height: "70px" }}
                            src={`${item.productId?.images?.[0]}`}
                            alt="product"
                          />
                          <span>
                            {item.productId?.title} × {item.quantity}
                          </span>
                          <span>{item.price * item.quantity} $</span>
                        </li>
                      ))}
                    </ul>

                    <p className="fw-bold">
                      Total Amount: {selectedOrder.totalAmount}$
                    </p>

                    <SelectBox
                      className="me-lg-5"
                      value={selectedOrder.status || "Awaiting Payment"}
                      onChange={(value) =>
                        updateOrderStatus(selectedOrder._id, value)
                      }
                      array={[
                        { _id: "Awaiting Payment", name: "Awaiting Payment" },
                        { _id: "Paid", name: "Paid" },
                        { _id: "Sent", name: "Sent" },
                        { _id: "Delivered", name: "Delivered" },
                        { _id: "Returned", name: "Returned" },
                      ]}
                      text="Change order status:"
                      bcolor="primary"
                      textcolor="dark"
                      bgcolor="white"
                      margin="2"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default Orders;

